module.exports = function getResource(label) {
    const resources = { qty: 'Quantité', loved: 'Favoris', moveToLoves: 'Déplacer vers les favoris', getItSooner: 'Obtenir plus rapidement' };
    return resources[label];
};
